import { render, staticRenderFns } from "./PaymentRequestRecipient.vue?vue&type=template&id=1036ab2d"
import script from "./PaymentRequestRecipient.vue?vue&type=script&lang=js"
export * from "./PaymentRequestRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports